import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-wrapper" }
const _hoisted_2 = { class: "form-fields-wrapper" }
const _hoisted_3 = { class: "form-buttons-wrapper" }

import { $api } from "@/services/api";
import { reactive, watch, ref } from "vue";
import type { FieldSchema, FormSchema } from "@/models/form";
import BaseFormField from "@/components/shared/BaseFormField.vue";
import { useStore } from "vuex";
import NextButton from "@/components/shared/NextButton.vue";
import useValidation from "@/use/validation";
import type { Applicant, Address } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import type { NameInputRequest, StipulationInputRequest } from "@/models/api";
import _ from "lodash";

interface Props {
  address?: Address;
  applicant: Applicant;
  stip: Stipulation;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NameInput',
  props: {
    address: {},
    applicant: {},
    stip: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

useStore();

const props = __props;

const emit = __emit;

const { validateForm } = useValidation();

let personalInfo = ref({} as any);

const submittingData = ref<boolean>(false);

const schema = reactive<FormSchema>({
  firstName: {
    name: "firstName",
    type: "text",
    label: "First Name",
    required: true,
    errorMessage: "First Name is required.",
    maxLength: 40,
  } as FieldSchema,
  middleName: {
    name: "middleName",
    type: "text",
    label: "Middle Name",
    required: false,
    maxLength: 40,
  } as FieldSchema,
  lastName: {
    name: "lastName",
    type: "text",
    label: "Last Name",
    required: true,
    errorMessage: "Last Name is required.",
    maxLength: 40,
  } as FieldSchema,
} as FormSchema);

function handleMiddleNameFieldValidation(value: string) {
  if (value && value.length > 0) {
    schema.middleName.required = true;
  } else {
    personalInfo.value.middleName = undefined;
    schema.middleName.required = false;
  }
}

async function submit() {
  submittingData.value = true;
  const valid = validateForm(schema, personalInfo.value);
  if (valid) {
    const request = {
      applicationStipulationId: props.stip?.id,
      applicationId: props?.stip?.applicationId,
      nameInput: {
        firstName: personalInfo.value.firstName,
        middleName: personalInfo.value.middleName,
        lastName: personalInfo.value.lastName,
      } as NameInputRequest,
    } as StipulationInputRequest;

    const response = await $api.applications.addStipInput(props?.stip?.applicationId, request);

    if (response) {
      // updates stip status to pending
      let updatedNameVerificationStip = props.stip;
      updatedNameVerificationStip.stipulationStatusId = response.stipulationStatusId;
      updatedNameVerificationStip.stipulationStatusName = response.stipulationStatusName;

      emit("success", updatedNameVerificationStip);

      submittingData.value = false;
    } else {
      submittingData.value = false;
    }
  } else {
    submittingData.value = false;
  }
}

watch(
  () => _.cloneDeep(personalInfo.value),
  (currentValue, oldValue) => {
    if (currentValue.middleName || currentValue.middleName === "") {
      handleMiddleNameFieldValidation(currentValue.middleName);
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseFormField, {
        modelValue: _unref(personalInfo).firstName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(personalInfo).firstName) = $event)),
        schema: schema.firstName,
        autocomplete: "given-name"
      }, null, 8, ["modelValue", "schema"]),
      _createVNode(BaseFormField, {
        class: "noWrapLabelText",
        modelValue: _unref(personalInfo).middleName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(personalInfo).middleName) = $event)),
        schema: schema.middleName,
        autocomplete: "additional-name"
      }, null, 8, ["modelValue", "schema"]),
      _createVNode(BaseFormField, {
        modelValue: _unref(personalInfo).lastName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(personalInfo).lastName) = $event)),
        schema: schema.lastName,
        autocomplete: "family-name"
      }, null, 8, ["modelValue", "schema"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(NextButton, {
        onClick: submit,
        text: "Submit"
      })
    ])
  ]))
}
}

})